import { createReducer, on } from '@ngrx/store';
import * as redemptionActions from '../actions/redemptions.action';

export interface RedemptionsState {
  redemptions: any;
}
export const initialState: any = {};

export const redemptionsReducer = createReducer(
  initialState,
  on(redemptionActions.redemptionsSuccess, (state, result) => ({redemptions: result})),
  on(redemptionActions.redemptionsFailure, (state, result) => ({redemptions: result})),
  // on(countryActions.countriesSuccess, (state, {countries}) => [...countries])
);
